import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'chart'
})
export class ChartPipe implements PipeTransform {

  transform(value: any[], ...args: unknown[]): unknown {
    var result = [];
    if (value) {
      value.reduce(function(res, value) {
          if (!res[value.dateScheduled]) {
            res[value.dateScheduled] = { dateScheduled: ''+value.dateScheduled };
            result.push(res[value.dateScheduled])
          }
          // if (isNaN(res[value.dateScheduled][value.companyName])) {
          //   res[value.dateScheduled][value.companyName] = value.dispersionAmount;
          // }else{
          //   res[value.dateScheduled][value.companyName] += value.dispersionAmount;
          // }
          if (isNaN(res[value.dateScheduled]['total'])) {
            res[value.dateScheduled]['total'] = value.dispersionAmount;
          }else{
            res[value.dateScheduled]['total'] += value.dispersionAmount;
          }
          return res;
        }, {});
        console.log('acumuladoRed',result);
      return result;
    }
  }

}
